import React, { useState } from 'react'
import {LogOutCircleIcon} from '../../components/Icons'
import { Button, Modal } from 'react-bootstrap'
import { Link, NavLink, useNavigate } from "react-router-dom";
import { logout } from '../../slice/authSlice';
import './logOut.scss';
import { logOut } from '../../services/auth.service';
import { selectUser } from '../../slice/authSlice';
import { useSelector, useDispatch } from "react-redux";
import { clearUserLocation } from '../../slice/commonSlice';
import { setUserLocation } from '../../slice/commonSlice';
const LogOut = (props) => {
    const [show, setShow] = useState(true);
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(selectUser);
    const handleLogout = async () => {
      const paylaod ={
        deviceId : "deedid"
      }

      localStorage.setItem('accessToken', '')
      const result = await logOut(paylaod);
      dispatch(clearUserLocation());
      dispatch(logout());
      // navigator.geolocation.getCurrentPosition(
      //       (position) => {
      //         dispatch(setUserLocation({
      //           lat: position.coords.latitude,
      //           long: position.coords.longitude
      //         }))
      //       },
      //       (error) => {
      //         console.error('Error getting location:', error.message);
      //       }
      //     );
      setShow(false);
      navigate("/");
      // window.location.reload();
      props.setLogoutModel(false);
  }
  return (
    <>
        <Modal show={props.logoutModel} size="sm" aria-labelledby="contained-modal-title-vcenter"
          onHide={() => props.setLogoutModel(false)}
                centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <div className='logout-modal-wrapper'>
                        <div className='icon-wrap'><LogOutCircleIcon/></div>
                        <div className='logout-title'>Logout</div>
                        <div className='logout-message'>Are you sure you want to logout?</div>
                        <div className='w-100 logout-btn-wrapper'><Button onClick={()=>handleLogout()} variant='outline-primary'>Yes</Button> <Button onClick={()=>props.setLogoutModel(false)} variant='outline-primary'>No</Button></div>
                    </div>
                </Modal.Body>
            </Modal>
    </>
  )
}

export default LogOut
